import { useEffect, useRef, useState } from 'react';
import 'select2/dist/css/select2.min.css';
import data from './data';
import { useNavigate } from 'react-router-dom';
import ShimmerSearch from '../shimmerEffect/shimmersearch';

export const SearchTrello = ({ serachBoard, setCardDetail, handleShow }) => {
  const [query, setQuery] = useState('');
  const [task, setTask] = useState([]);
  const [suggestionVissible, setSuggestionVisible] = useState(false);
  const [filteredItems, setFilteredState] = useState([]);
  const [isSearching, setIsSearching] = useState(true);
  const { tracks } = data;
  const { items } = tracks;
  const [searchCount, setSearchCount] = useState(0);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  console.log(serachBoard, 'serachBoard');

  const getFilteredItems = (query, tasks) => {
    setIsSearching(false);
    if (!query) {
      return tasks;
    }

    return tasks.filter((task) => {
      const queryLower = query.toLowerCase();
      return (
        query &&
        (task.title.toLowerCase().includes(queryLower) ||
          (task.trello_url && task.trello_url.toLowerCase().includes(queryLower)) ||
          (task.client?.name && task.client.name.toLowerCase().includes(queryLower))||
          (task.client?.email && task.client.email.toLowerCase().includes(queryLower))
        )
      );
    });
    
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSuggestionVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [suggestionVissible]);

  useEffect(() => {
    setTimeout(() => {
      setSearchCount(1);
    }, 5000);
  }, []);

  const handleInput = (e) => {
    var search = e.target.value;
    setQuery(search);
    if (search.length > 0) setSuggestionVisible(true);
    else setSuggestionVisible(false);
  };

  const handleClearBtn = () => {
    if (query !== '') {
      setQuery('');
    } else {
      setSuggestionVisible(false);
    }
  };

  useEffect(() => {
    setFilteredState(getFilteredItems(query, serachBoard));
  }, [query, serachBoard]);

  useEffect(() => {
    if (serachBoard?.length > 0) {
      setTask(serachBoard);
    }
  }, [serachBoard]);

  const onOpenModalSearch = (data) => {
    console.log(data);
    setCardDetail(data);
    handleShow();
    setQuery('');
    setSuggestionVisible(false);
    navigate('?code=' + data.code);
  };
  
  return (
    <>
      {isSearching ? (
        <ShimmerSearch />
      ) : (
        <div className="input-wrap d-flex">
          <i className="fas fa-search search-icon input-ic"></i>
          <input
            className="form-control"
            onChange={handleInput}
            onClick={() => setSuggestionVisible(true)}
            value={query}
            type="text"
            readOnly={false}
            name="product-search"
            id="product-search"
            placeholder="Search"
          />
          <i
            onClick={handleClearBtn}
            className="fas fa-times cross-icon input-ic"
          ></i>
        </div>
      )}

      {suggestionVissible ? (
        <div className="wrapSearchResult" ref={dropdownRef}>
          <h4 className="searchHeading">Task</h4>
          <ul className="searchResult">
            {filteredItems.map((item) => (
              <li
                key={item.id} // Assuming each item has a unique id
                className={item?.deleted_at ? 'trash' : 'taskWrap'}
                onClick={() => onOpenModalSearch(item)}
              >
                <span className="material-symbols-outlined">laptop_mac</span>
                <div className="taskNameWrap">
                  <span
                    className={item?.deleted_at ? 'titleTask2' : 'titleTask'}
                  >
                    {item.title}
                  </span>
                  <span className="taskStatus">
                    {item.board_list?.department?.name} ::{' '}
                    {item.board_list?.title}
                    {item.client?.name ? ' :: ' + item.client?.name : ''}
                    {item.client?.email ? ' :: ' + item.client?.email : ''}
                    <span className={`search_due_date`}>
                      {item?.deleted_at
                        ? 'Deleted At: ' +
                          new Date(item.deleted_at).toLocaleDateString('en-GB')
                        : ''}
                    </span>
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
};
